import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { useLink } from '../../hooks/useLink.js';
import { getAspectsAttributes } from '../../utils/dataAttributes.js';
import { style } from '../../utils/style.js';
export const LinkWrapper = JSX(({ className = '', href, target, onClick, data, children }) => {
    const link = useLink();
    const linkProps = link({ href, target, onClick });
    const Tag = href ? 'a' : 'div';
    return (_jsx(Tag, { className: style('block', className), ...(href ? linkProps : {}), role: href ? 'link' : 'none', ...getAspectsAttributes(data), children: children }));
});
//# sourceMappingURL=LinkWrapper.js.map